var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.nowIs,{tag:"component",attrs:{"datas":_vm.nowProps},on:{"click":_vm.countPlus}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }